import { FC, useState } from 'react';
import { router } from '@inertiajs/react';

import { AppModalProps } from '@/types/modal.type';
import { ModalView } from '@/Components/ModalView';
import { Button } from '@/Components/Button';
import { FlickAnimation } from '@/Components/FlickAnimation';
import { FruitBlueberrySvg } from '@/Components/Icons/FruitBlueberrySvg';
import { useToast } from '@/hook/useToast';

type DismissGetStartedChecklistProps = AppModalProps<{}>;

export const DismissGetStartedChecklist: FC<
    DismissGetStartedChecklistProps
> = ({ payload, onClose }) => {
    const { showToast, hideToast } = useToast();

    const onSaveClick = () => {
        router.patch(
            route('settings.profile.help-update'),
            { is_help_enabled: false },
            {
                onSuccess: () => {
                    showToast({
                        variant: 'success',
                        label: `Help & Assistance preferences updated`,
                    });
                },
                onError: (errors) => {
                    Object.keys(errors).forEach((errorKey) => {
                        showToast({
                            variant: 'danger',
                            label: errors[errorKey],
                        });
                    });
                },
            },
        );

        onClose();
    };

    return (
        <ModalView
            maxWidth="sm"
            onClose={onClose}
            contentContainerClassName="py-6 px-6 text-brand-ocean flex flex-col justify-center items-center">
            <div className="relative min-w-60 h-24 flex items-center justify-center">
                <FlickAnimation className="absolute z-10 top-0 left-14" />
                <div className="absolute bottom-3.5 right-20">
                    <FruitBlueberrySvg className="" />
                </div>
            </div>
            <div className="mt-2 w-full text-heading-five text-left text-brand-ocean mb-2">
                Hide Getting Started guides & useful links
            </div>
            <div className="w-full text-body-text-15 text-left text-brand-ocean mb-2">
                If you would like to access the guides or checklist in future,
                find the option in Your Profile settings, under Help &
                Assistance.
            </div>
            <div className="mt-4 w-full flex flex-row items-center justify-center space-x-3">
                <Button
                    className="flex-1 h-9"
                    variant="default"
                    onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    className="flex-1 h-9"
                    variant="primary"
                    onClick={onSaveClick}>
                    Turn off & hide
                </Button>
            </div>
        </ModalView>
    );
};
